import React, { useState } from "react";
import '../NumberButton/NumberButton.css'

function NumberButton(props) {
  return <button className="number-button-1" >{props.children}</button>;
}

export default NumberButton;
